// extracted by mini-css-extract-plugin
export default {"form":"Subscription_form__x3uvl","input":"Subscription_input__eFjL2","btn":"Subscription_btn__EuCDF"};